import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { RETREAT_STYLES } from "../../../data/sitePages";
import { photoFromPool } from "../../../data/themePhotos";
import { track } from "../../../lib/analytics";

export const RetreatStyles = () => (
  <section id="retreat-styles" data-testid="retreat-styles" className="mx-auto max-w-[1400px] px-6 pt-24 pb-12 md:px-10 md:pt-32">
    <div className="mb-10">
      <p className="overline text-brand-inkSoft">Section 01</p>
      <h2 className="mt-3 font-display text-3xl leading-tight text-brand-ink md:text-5xl">Choose your retreat style</h2>
    </div>
    <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
      {RETREAT_STYLES.map((s, i) => {
        const card = (
          <>
            <div className="card-img-wrap img-gradient-overlay relative aspect-[4/3] w-full bg-brand-bg2">
              <img src={photoFromPool(s.theme, i)} alt={s.label} loading="lazy" className="card-img absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-x-0 bottom-0 z-10 flex items-end justify-between p-5">
                <h3 className="font-display text-2xl leading-tight text-white">{s.label}</h3>
                <ArrowUpRight size={20} className="text-white transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </div>
            </div>
            <p className="mt-3 px-1 text-sm text-brand-inkSoft">{s.blurb}</p>
          </>
        );
        const cls = "group block fade-up";
        const style = { animationDelay: `${Math.min(i, 6) * 60}ms` };
        const onClick = () => track("retreat_type_card_clicked", { label: s.label, to: s.to });
        return s.to.startsWith("/#") ? (
          <a key={s.label} href={s.to} onClick={onClick} data-testid={`style-card-${i}`} className={cls} style={style}>{card}</a>
        ) : (
          <Link key={s.label} to={s.to} onClick={onClick} data-testid={`style-card-${i}`} className={cls} style={style}>{card}</Link>
        );
      })}
    </div>
  </section>
);

export default RetreatStyles;
